<template>
  <div id="fy_map" class="parent_container">
    <h2 class="text-center">公司地址：广东省广州市增城区新塘镇东洲村格水新村鸡冲滘四路77号</h2>
    <iframe src="./../../static/map/map.html" height="1000" width="100%" frameborder="0" scrolling="no" align="left" id="map"></iframe>
  </div>
</template>

<script>
  import './../assets/css/fy_map.css'
    export default {
        name: "fy_map",

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_map.vue